if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.error = false;
      this.onSubmitHandler = this.onSubmitHandler.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.drawer = document.querySelector("[data-cart-sidebar]");
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      this.errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessageWrapper?.querySelector('.product-form__error-message');
      this.cart = document.querySelector('bz-cart-sidebar, cart-popup');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.loader = this.submitButton?.querySelector('[data-atc-loader]');

      this.form?.addEventListener('submit', this.onSubmitHandler);
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);

      const formData = new FormData(this.form);
      // const wrapId = this.dataset.skipGift ? '' : this.closest('bz-product-info')?.querySelector('[data-gift-variant]')?.value;
      const info = this.closest('bz-product-info');
      const planField = info?.querySelector('[data-selling-plan]') || this.form.querySelector('[name="selling_plan"]');
      if (planField && !planField.disabled && planField.value) {
        formData.set('selling_plan', planField.value);
      }
      const wrapId = this.dataset.skipGift ? '' : info?.querySelector('[data-gift-variant]')?.value;
      const headers = { 'X-Requested-With': 'XMLHttpRequest' };
      let body = formData;
      if (wrapId) {
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify(this.giftWrapItems(formData, wrapId));
      }

      this.submitButton.classList.add("loading");
      this.loader?.classList.remove("hidden");

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body,
          headers
        });

        const data = await res.json();
        if (!res.ok || data.errors || data.status) {
          this.error = true;
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: data.errors || {},
            message: data.description || 'Error adding product to cart'
          });
          this.handleErrorMessage(data.description || 'Error adding product to cart');
          return;
        }
        this.error = false;
        const quickViewModal = document.querySelector('wb-modal');
        if (quickViewModal) quickViewModal.close();

        if (this.cart) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: data
          });
          if (this.drawer) {
            this.drawer.classList.remove('cart_blank');
          }
          const addedId = data.product_id || data.items?.[0]?.product_id;
          if (this.cart.tagName.toLowerCase() === 'cart-popup') {
            this.cart.showSingleProduct?.(data.items ? data.items[0] : data);
            this.cart.updateCartCountFromCart?.();
          } else {
            this.cart.openCart?.(addedId);
          }
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

      } catch (err) {
        console.error(err);
        this.error = true;
        this.handleErrorMessage('Something went wrong.');
      } finally {
        setTimeout(() => {
          this.loader?.classList.add("hidden");
          this.submitButton?.classList.remove('loading');
          if (!this.error) this.submitButton?.removeAttribute('aria-disabled');
        }, 300);
      }
    }

    handleErrorMessage(message = null) {
      if (this.hideErrors) return;
      if (!this.errorMessageWrapper) return;

      this.errorMessageWrapper.toggleAttribute('hidden', !message);

      if (message) {
        this.errorMessage.textContent = message;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = this.submitButton.dataset.text || window.variantStrings?.addToCart || 'Add to cart';
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }

    giftWrapItems(formData, wrapId) {
      const group = `gw_${Date.now().toString(36)}`;
      const properties = { _gift_group: group };
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      }
      const main = {
        id: Number(formData.get('id')),
        quantity: Number(formData.get('quantity') || 1),
        properties
      };
      const plan = formData.get('selling_plan');
      if (plan) main.selling_plan = plan;
      return {
        items: [
          main,
          {
            id: Number(wrapId),
            quantity: main.quantity,
            properties: { _gift_parent: group }
          }
        ]
      };
    }
  });
}

if (!customElements.get('gift-wrap')) {
  customElements.define('gift-wrap', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('[data-gift-variant]');
      this.label = this.querySelector('[data-gift-label]');
      this.modal = document.getElementById(this.dataset.modal);
      this._onEditor = (event) => {
        if (event.type === 'shopify:block:deselect' && event.target !== this) return;
        if (event.type === 'shopify:section:unload' && !event.target.contains(this)) return;
        this.close();
      };
      document.addEventListener('shopify:block:deselect', this._onEditor);
      document.addEventListener('shopify:section:unload', this._onEditor);
      this.modal?.querySelectorAll('[data-gift-pick]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!this.input) return;
          this.input.value = btn.dataset.variantId || '';
          if (this.label && btn.dataset.title) this.label.textContent = btn.dataset.title;
          this.modal.querySelectorAll('[data-gift-pick]').forEach((el) => {
            const on = el === btn;
            el.classList.toggle('is-selected', on);
            el.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          this.modal.querySelector('.close_modal')?.click();
        });
      });
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:deselect', this._onEditor);
      document.removeEventListener('shopify:section:unload', this._onEditor);
      this.close();
    }

    close() {
      this.modal?.classList.remove('drawer_active');
      if (document.querySelector('.drawer_content.drawer_active, .popup_wrapper.drawer_active')) return;
      document.body.classList.remove('Vdrawer_open', 'overflow-hidden');
    }
  });
}